import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setWorksheetTitle } from "../../../worksheetSlice";

import CloseButton from "../../../../../components/CloseButton";

const TitleSectionPage = ({ onClose, onClickNext }) => {
  const dispatch = useDispatch();

  const { worksheet } = useSelector((state) => state.worksheet);

  const [title, setTitle] = useState(worksheet.title);

  return (
    <div
      style={{
        position: "relative",
        backgroundColor: "#fff",
        borderRadius: "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CloseButton onClick={onClose} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "center",
          width: "300px",
          padding: "25px 60px 80px 30px",
          gap: "10px",
        }}
      >
        <span style={{ fontSize: "18px" }}>과제 제목 설정</span>
        <input
          type="text"
          placeholder="과제 제목을 입력해주세요."
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          style={{
            fontSize: "16px",
            width: "100%",
            padding: "10px",
            border: "1px solid #2D2D2D",
            borderRadius: "4px",
            boxSizing: "border-box",
          }}
        />
      </div>
      <div
        style={{
          position: "absolute",
          padding: "10px",
          bottom: "10px",
          left: "10px",
          right: "10px",
          display: "flex",
          justifyContent: "right",
          marginBottom: "10px",
          alignItems: "center",
        }}
      >
        {/* 다음 버튼 */}
        <button
          style={{
            padding: "5px 40px",
            backgroundColor: "#2D2D2D",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
          }}
          onClick={() => {
            dispatch(setWorksheetTitle(title));
            onClickNext();
          }}
        >
          다음
        </button>
      </div>
    </div>
  );
};

export default TitleSectionPage;
